import http from '../utils/request'

/** 获取流程关联的表单列表 */
export function getFormsByFlow(flowGuid) {
  return http.get(`/form/list/${flowGuid}`)
}

/** 获取单个表单完整数据（含 FormContent、JSContent） */
export function getFormById(formGuid) {
  return http.get(`/form/${formGuid}`)
}

/** 保存表单 */
export function saveForm(data) {
  return http.post('/form', data)
}

/** 删除表单 */
export function deleteForm(formGuid) {
  return http.delete(`/form/${formGuid}`)
}
